module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Full-Reuenthal-6741c345d903e0c1dfc30798a1e2880f.svg";